export const contactFields = (self) => {
  return [
    {
      key: 'label',
      label: self.$t('trackingTemp.contact.label'),
    },
    {
      key: 'phoneNumber',
      label: self.$t('trackingTemp.contact.phoneNumber'),
    },
    {
      key: 'location.fullName',
      label: self.$t('trackingTemp.contact.location'),
      tdClass: 'td__overflow-ellipsis',
    },
    {
      key: 'createdOn',
      label: self.$t('trackingTemp.contact.createdOn'),
    },
    {
      key: 'createdBy',
      label: self.$t('trackingTemp.contact.createdBy'),
    },
  ]
}
